import React from "react";

const Eye = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M2 18.333C3.39 10.748 10.026 5 18 5s14.608 5.748 16 13.333c-1.39 7.586-8.026 13.334-16 13.334S3.392 25.919 2 18.333zm16 7.408c1.961 0 3.842-.78 5.229-2.17a7.414 7.414 0 000-10.476 7.388 7.388 0 00-10.458 0 7.414 7.414 0 000 10.476A7.388 7.388 0 0018 25.741zm0-2.963a4.433 4.433 0 01-3.137-1.302 4.448 4.448 0 010-6.285 4.433 4.433 0 016.274 0 4.449 4.449 0 010 6.285A4.433 4.433 0 0118 22.778z"
            fill={fill}
        />
    </svg>
);

export default Eye;
